import * as React from 'react';

import Tooltip from 'components/Tooltip';
import StatusLabel from 'components/status-label/StatusLabel';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import ClientApprovalEntryActions from '../client-approval-entry-actions/ClientApprovalEntryActions';

import ClientApprovalGalleryContext from '../../context/ClientApprovalGalleryContext';

import { __t, applyTranslations } from 'utils/language';

import './client-approval-entry-gallery-helper.scss';

applyTranslations(require('./client-approval-entry-gallery-helper.i18n.json'));

const ClientApprovalEntryGalleryFooter = (item): React.ReactNode => {
  const isReviewed = item.status === 'approved' || item.status === 'declined';

  return (
    <ClientApprovalGalleryContext.Consumer>
      {
        (context) => {
          if (!context) {
            return null;
          }

          return (
            <div className="client-approval-entry-gallery-footer">
              <div
                className="client-approval-entry-gallery-footer__filename text-overflow-ellipsis"
                title={item.fileName}
              >
                {item.fileName}
              </div>
              {
                !isReviewed && (
                  <div className="client-approval-entry-gallery-footer__actions">
                    <ClientApprovalEntryActions
                      onApprove={() => context.onAssetApprovalChange(Number(item.id), 'approved')}
                      onDecline={() => context.onAssetApprovalChange(Number(item.id), 'declined')}
                    />
                  </div>
                )
              }
              {
                item.status === 'approved' && (
                  <div className="client-approval-entry-gallery-footer__status">
                    <StatusLabel
                      size="nano"
                      type="success"
                      background="transparent"
                      label={__t('client_approval_entry_gallery_helper.status.approved')}
                    />
                  </div>
                )
              }
              {
                item.status === 'declined' && (
                  <div className="client-approval-entry-gallery-footer__status">
                    <StatusLabel
                      size="nano"
                      type="danger"
                      background="transparent"
                      label={__t('client_approval_entry_gallery_helper.status.declined')}
                    />
                  </div>
                )
              }
              {
                isReviewed && (
                  <Tooltip
                    message={__t('client_approval_entry_gallery_helper.status_reset')}
                    width="auto-compact"
                    classNameWrapper="client-approval-entry-gallery-footer__reset-action"
                  >
                    <SVGDynamicIcon
                      name="rotate-left-custom-fg"
                      width={16}
                      height={14}
                      customColor="grey"
                      onClick={() => context.onAssetApprovalChange(Number(item.id), 'pending')}
                      clickable
                    />
                  </Tooltip>
                )
              }
            </div>
          );
        }
      }
    </ClientApprovalGalleryContext.Consumer>
  );
};

export default ClientApprovalEntryGalleryFooter;
